declare global {
  interface Window {
    __alloyMonitors?: [
      {
        onNetworkResponse?(data: TargetNetworkResponse): void;
        onBeforeNetworkRequest?(data: TargetNetworkResponse): void;
      }
    ];
  }
}

export interface TargetNetworkResponse {
  payload: {
    events: [
      {
        xdm: {
          eventType: string;
        },
      }
    ];
  };
  parsedBody?: {
    handle?: [
      {
        type?: string;
        payload?: AdobeTargetResponsePersonalizationPayload[] | AdobeTargetResponseIdentityPayload[]
      }
    ]
  };
}

export interface AdobeTargetResponsePersonalizationPayload {
  id?: string;
  scope?: string;
  items?: [
    {
      data?: {
        content?: PromoBannerContent | TopLevelMenuContent | HomePageSectionOrder | MealBuilderProteinOrder | AEMGuestOrderCreateAccountFragment | DynamicUpsellContent;
      }
    }
  ];
  scopeDetails?: any;
}

export interface AdobeTargetResponseIdentityPayload {
  id: string,
  namespace: {
    code: string
  }
}

export interface PropositionDisplayPayload {
  propositions: 
    {
      id: string,
      scope: string,
      scopeDetails: any, // Putting 'any' here because we are sending back whatever Adobe Target sent to the client
    }[]  
}

export interface PromoBannerContent {
  master: AemPromoBanner;
  bannerType: string;
}

export interface DynamicUpsellContent {
  upsellItems: string[];
}

export interface TopLevelMenuContent {
  firstItem: string; 
}

export interface MealBuilderProteinOrder {
  proteinOrder: string[];
}

export interface HomePageSectionOrder {
  isOneTapSectionAboveTopLevelMenu: boolean;
}

export enum TargetPayloadType {
  Personalization = 'personalization:decisions',
  CmgTarget = 'cmg_target',
  Identity = 'identity:result'
}

export enum TargetDecisionScope {
  HeroPromoBannerTop = 'hero-promo-banner-top',
  LoyaltyBannerHomePage = 'loyalty-banner-homepage',
  TopLevelMenu = 'top-level-menu',
  DualPromoBanner = 'dual-promo-banner',
  FeaturedMeals = 'featured-meals', 
  LargePromoOrder = 'large-promo-order',
  HomePageSectionOrder = 'hp-content-order',
  MealBuilderProteinOrder = 'mb-protein-order',
  OrderConfirmationGuest= 'order-confirmation-create-account-banner',
  CartUpsellItems = 'cart-upsell-items-web',
  Global = '__view__',
}

export enum TargetIdentityType {
  ECID = 'ECID'
}

export interface UtmParameters {
  utmCampaign: string | (string | null)[];
  utmContent: string | (string | null)[];
  utmMedium: string | (string | null)[];
  utmSource: string | (string | null)[];
  utmTerm: string | (string | null)[];
  adSetId: string | (string | null)[];
}

